import { element } from 'protractor';
import { DOCUMENT } from '@angular/common';
import { SeoClient, GetSeoMetaTextsResponseModel } from './../api/WickedApiClient';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

interface SeoData {
  title:string,
  description: string
}

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  defaultData: SeoData = { title: "Wickedlist.com - long term relationship or casual dating!", description: `Wickedlist - free adult personal classifieds: long term relationship and casual dating. Find love or casual thing for straight, gay, trans, couples in the US!` };

  seoData: { [key: number]: SeoData } = {
    0: this.defaultData,
    1: { title: "Woman seek man - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Woman seeking a man on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    2: { title: "Woman seek woman - free dating in US | Wickedlist.com", description: "\u2764 Woman seeking a woman on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    3: { title: "Woman seek couple - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Woman seeking a couple on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    4: null,
    5: { title: "Man seek woman - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Man seeking a woman on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    6: { title: "Man seek man - free dating in US | Wickedlist.com", description: "\uD83D\uDD25 Man seeking a man on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    7: { title: "Man seeking couple - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Man seeking couple on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    8: { title: "", description: "" },
    9: { title: "Couple seek woman - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek woman on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    10: { title: "Couple seek man - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek man on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    11: { title: "Couple seek couple - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek couple on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    12: { title: "Couple seek threesome - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek third on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
    13: null,
    14: null,
    15: null,
    16: null,
    17: null,
  }
   

  constructor(private meta: Meta, private title: Title, private seoClient: SeoClient, @Inject(DOCUMENT) private dom) {
  }

  toUTF16(codePoint) {
  var TEN_BITS = parseInt('1111111111', 2);
  function u(codeUnit) {
    return '\\u' + codeUnit.toString(16).toUpperCase();
  }

  if (codePoint <= 0xFFFF) {
    return u(codePoint);
  }
  codePoint -= 0x10000;
  var leadSurrogate = 0xD800 + (codePoint >> 10);
  var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);
  return u(leadSurrogate) + u(tailSurrogate);
}

  updateMeta(title: string, description: string) {
    this.meta.updateTag({ name: 'description', content: description });
    this.title.setTitle(title);
  }

  updateMetaDefaults() {
    this.updateMeta(this.defaultData.title, this.defaultData.description);
  }

  updateMetaTagsBySearch(relationShipId: number) {
    if (this.seoData[relationShipId]) {
      let data = this.seoData[relationShipId];
      this.updateMeta(data.title, data.description);
    } else {
      this.updateMetaDefaults();
    }
  }

  updateCanonicalLink(url:string) {
    var fullUrl = window.location.href
    var arr = fullUrl.split("/");
    var domain = arr[0] + "//" + arr[2];
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel','canonical');
    element.setAttribute('href',domain+url);
  }

  removeCanonicalLink(){
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element!=null) {
      element.remove();
    }
  }

  getMetaSeo(url): Promise<GetSeoMetaTextsResponseModel> {
    return new Promise<GetSeoMetaTextsResponseModel>((resolve, reject) => {

      this.seoClient.getMetaSeo(url).subscribe((result) => {
        if (result.error && result.error != "") {
          reject(result.error)
        } else resolve(result)
      })
    })
  }
      
}
